import { GoogleLogin } from '@react-oauth/google';
import React, { useState } from 'react'
import  { jwtDecode } from 'jwt-decode';
function Login() {
    const [showModal, setShowModal] = useState(false);
  const handleSuccess = (credentialResponse) => {
    const user = jwtDecode(
      credentialResponse.credential
    );
    console.log("User Info:", user);
    setShowModal(false);
  };
  return (
       <div>
      {/* Open Modal Button */}
      <button onClick={() => setShowModal(true)}>
        Open Google Login
      </button>
      {/* Modal */}
      {showModal && (
        <div className="modalOverlay">
          <div className="modalBox">
            <button
              className="closeBtn"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
            <h2>Login with Google</h2>
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={() => {
                console.log("Login Failed");
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
export default Login
